import { type MouseEvent } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export interface SectionRefreshButtonProps {
  onRefresh: () => void;
  isRefreshing?: boolean;
  ariaLabel: string;
  tooltip: string;
}

/**
 * Atualiza a seção sem abrir/fechar o header.
 * O clique para no mesmo ponto do accordion de comunicações.
 */
export function SectionRefreshButton({
  onRefresh,
  isRefreshing = false,
  ariaLabel,
  tooltip,
}: SectionRefreshButtonProps) {
  const stopToggle = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <Tooltip title={tooltip}>
      <span style={{ display: "inline-flex" }}>
        <IconButton
          size="small"
          aria-label={ariaLabel}
          disabled={isRefreshing}
          onMouseDown={stopToggle}
          onClick={(event) => {
            stopToggle(event);
            onRefresh();
          }}
        >
          <RefreshIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
